var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"centered-container text-button"},[_c('h1',[_vm._v("DOMINIO INCORRECTO")]),_c('h3',[_vm._v("Te invitamos a seguir recorriendo nuestra página")]),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',{attrs:{"outlined":"","color":"primary"}},[_vm._v(" página principal")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }